/*
 *  I10DIABOUCECSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-13 12:44:03 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I10DIABOUCECS_SECTION_0_TITLE: "Calculez le diamètre de tout ou partie d'une boucle ECS",
  I10DIABOUCECS_COEFFICIONT_MAJORATION: 'Coefficient de majoration',
  I10DIABOUCECS_coeffMajoration_mail: 'Type de bâtiment',
  I10DIABOUCECS_in_tempEauFroide: 'Température eau froide',
  I10DIABOUCECS_in_tempBouclage: 'Température eau chaude',
  I10DIABOUCECS_SECTION_1_TITLE: '',
  I10DIABOUCECS_SECTION_1_TITLE_mail: 'Inventaire des équipements sanitaires',
  I10DIABOUCECS_in_evier: 'Evier',
  I10DIABOUCECS_in_lavabo: 'Lavabo',
  I10DIABOUCECS_in_bidet: 'Bidet',
  I10DIABOUCECS_in_baignoire: 'Baignoire',
  I10DIABOUCECS_in_douche: 'Douche',
  I10DIABOUCECS_in_robinetdemi: 'Robinet 1/2',
  I10DIABOUCECS_in_robinetquart: 'Robinet 3/4',
  I10DIABOUCECS_in_lavemain: 'Lave mains',
  I10DIABOUCECS_in_baclaver: 'Bac à laver',
  I10DIABOUCECS_in_linge: 'Machine à laver le linge',
  I10DIABOUCECS_in_vaiselle: 'Machine à laver la vaisselle',
  I10DIABOUCECS_SECTION_2_TITLE: '',
  I10DIABOUCECS_res_somme_debit: 'Débit de base',
  I10DIABOUCECS_res_coeff_simul: 'Coéfficient de simultanéité',
  I10DIABOUCECS_res_debit_probable: 'Débit probable',
  I10DIABOUCECS_res_diam_int_probable: 'Diamètre recommandé',
  I10DIABOUCECS_res_vitesse_sil_max: 'Vitesse silencieuse maximum',
  I10DIABOUCECS_SECTION_3_TITLE: 'Choix conduite allée',
  I10DIABOUCECS_SECTION_3_TITLE_mail: 'Choix conduite',
  I10DIABOUCECS_tube_uuid: 'Diamètre intérieur :',
  I10DIABOUCECS_res_debit_max_prob: 'Débit maximum probable',
  I10DIABOUCECS_res_vitesse_debit_maxi: 'Vitesse du débit maxi dans la conduite',
  I10DIABOUCECS_canalisationdebit_uuid: '',
  I10DIABOUCECS_canalisationdebit_uuid_mail: 'Type de canalisation',
  I10DIABOUCECS_nonconforme: 'Diamètre non conforme',
  I10DIABOUCECS_conforme: 'Diamètre conforme'
}
